import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import firebase from 'firebase/app'
import { Provider, useSelector } from 'react-redux'
import { createFirestoreInstance } from 'redux-firestore'
import { ReactReduxFirebaseProvider } from 'react-redux-firebase'
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from './store/store'
import { BrowserRouter } from 'react-router-dom'
import ThemeContextProvider from './contexts/themeContext'
import { isLoaded } from 'react-redux-firebase'
import Loading from './components/Loading'

function AuthIsLoaded({ children }) {
    const profile = useSelector(state => state.firebase.profile)
    const auth = useSelector(state => state.firebase.auth)
    if (!isLoaded(auth) && !isLoaded(profile)) {
        return <Loading />;
    } else {
        if (!isLoaded(profile)) {
            return <Loading />
        } else {
            return children
        }
    }
}

const rrfConfig = {
    userProfile: "users",
    useFirestoreForProfile: true,
    attachAuthIsReady: true,
};

const rrfProps = {
    firebase,
    config: rrfConfig,
    dispatch: store.dispatch,
    createFirestoreInstance
};

ReactDOM.render(
    <BrowserRouter>
        <Provider store={store}>
            <PersistGate loading={true} persistor={persistor}>
                <ReactReduxFirebaseProvider {...rrfProps}>
                    <ThemeContextProvider>
                        <AuthIsLoaded>
                            <App />
                        </AuthIsLoaded>
                    </ThemeContextProvider>
                </ReactReduxFirebaseProvider>
            </PersistGate>
        </Provider>
    </BrowserRouter>,
    document.getElementById('root')
)